module.exports = __webpack_public_path__ + "static/img/common.26a77f4.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/home/pc/common.png
// module id = GMCm
// module chunks = 7